import TriMoji from "./TriMoji";

const CoffeeFeedback = TriMoji({ top: "🤲", mid: "✨", bottom: "☕️" });

export default CoffeeFeedback;
